<template>
    <div>
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('edit_city') }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="country" class="required">Country</label>
                        <app-input 
                            :placeholder = "$t('select_country_phd')" 
                            type = "advance-search-select"
                            fetch-url = "/countries/serverside/selectable-name"
                            listValueField = "name"
                            v-model = "country" 
                            :loaded-per-time = "5" 
                            :required = "true"  
                            :disabled = "true"
                        />
                        <br>
                        <label for="state" class="required">State</label>
                        <app-input 
                            :placeholder = "$t('select_country_phd')" 
                            type = "advance-search-select"
                            :fetch-url = "getUrl()"
                            listValueField = "name"
                            v-model = "state" 
                            :loaded-per-time = "5" 
                            :required = "true"  
                            :disabled="true"
                        />
                        <br>
                        <label for="name" class="required">City name</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="city"
                            placeholder="City name"
                        />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { readonly } from 'vue';
import {getCity} from './api/api';

export default {
    name: "AddCity",
    props :{
        city_id: {
            type: String|Number,
            default: null
        },
    },
    data() {
        return {
            country: "",
            state : "",
            city : "",
            cit_id : "",
        };
    },
    methods: {
        submit() {
            this.$emit("save", this.city, this.cit_id);
            this.country = "";
        },
        getUrl() {
            return `/countries/${this.country.id}/states`;
        },
        async getData(id) {
            const res = await getCity(id);
            if (res.data) {
                const data = res.data;
                this.country = {id : data.country_id, name : data.country};
                this.state = {id : data.state_id, name : data.state};
                this.city = data.city;
                this.cit_id = data.city_id;
            }
        }
    },
    mounted(){
        if (this.city_id) {
            this.getData(this.city_id);
        }
    }
};
</script>
  